// Every per-user setting, its default and its choices. Mirrors SETTINGS in
// backend/app/user_settings.py, which validates and stores them; add a setting in both places.
export const CLIP_END_BEHAVIOR = 'clip_end_behavior'

export const SETTINGS = {
  [CLIP_END_BEHAVIOR]: {
    label: 'After you finish marking a clip',
    help: 'What the video does once the clip you marked is saved.',
    default: 'pause_at_end',
    options: [
      {
        value: 'pause_at_end',
        label: 'Stay at the end of the clip, paused',
        description: 'Press play to carry on through the rest of the video, or select the clip to watch it again.'
      },
      {
        value: 'keep_playing',
        label: 'Keep playing from the end of the clip',
        description: 'The video carries straight on, so you can keep reviewing without stopping.'
      },
      {
        value: 'rewind_to_start',
        label: 'Go back to the start of the clip',
        description: 'Jumps back to the beginning of the clip you just marked, as earlier versions did.'
      }
    ]
  }
}

export const DEFAULT_SETTINGS = Object.freeze(
  Object.fromEntries(Object.entries(SETTINGS).map(([key, spec]) => [key, spec.default]))
)

// Known keys with allowed values only; anything else falls back to the default.
export const normalizeSettings = values => Object.fromEntries(Object.entries(SETTINGS).map(([key, spec]) => {
  const value = values && typeof values === 'object' ? values[key] : undefined
  return [key, spec.options.some(option => option.value === value) ? value : spec.default]
}))
